import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import {getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa, PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import alterarOrdem from '../../actions/trecho/alterarOrdem';
import buscarTrechos from '../../actions/trecho/buscarTrechos';
import ReactTooltip from 'react-tooltip';
import iconeBarCode from '../../img/icone-barcode.svg'
import buscarUltimosHistoricosTrecho from '../../actions/trecho/buscarUltimosHistoricosTrecho';
import iconAudoria from  '../../img/auditoria.png';

export class Trecho extends React.Component {
  selecionarTrecho (trecho) {
    this.props.selecionarTrecho(trecho)
    this.props.changeFieldValue('formularioCadastroTrecho',
      'idTrecho', trecho.id);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'cidadeDestino', {
        label: trecho.cidadeDestino.nome,
        value: trecho.cidadeDestino.id
      });
    this.props.changeFieldValue('formularioCadastroTrecho',
      'estadoDestino', {
        label: trecho.cidadeDestino.descricaoUf,
        value: trecho.cidadeDestino.uf
      });
    if (trecho.conexao) {
      this.props.changeFieldValue('formularioCadastroTrecho',
        'conexao', {
          label: `${trecho.conexao.prefixo ? trecho.conexao.prefixo : 'Prefixo não informado'}: ${trecho.conexao.cidadeOrigem.nome}-${trecho.conexao.cidadeOrigem.uf} -> ${trecho.conexao.cidadeDestino.nome}-${trecho.conexao.cidadeDestino.uf} `,
          value: trecho.conexao.id
        });
    }
    if(trecho.configuracaoBilhete) {
      this.props.preencherConfiguracoesBilheteSelecinados(trecho.configuracaoBilhete);
    }
    this.props.changeFieldValue('formularioCadastroTrecho',
      'preco', trecho.preco);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'duracao', trecho.duracao);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'taxaEmbarque', trecho.taxaEmbarque);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'pedagio', trecho.pedagio);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'quilometragem', trecho.quilometragem);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'pontoEmbarque', trecho.pontoEmbarque);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'plataformaEmbarque', trecho.plataformaEmbarque);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'ordem', trecho.ordem);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'ultimoTrecho', this.props.ultimoTrecho);

    this.props.changeFieldValue('formularioCadastroTrecho',
      'cidadeOrigem', trecho.cidadeOrigem);

    this.props.changeFieldValue('formularioCadastroTrecho',
      'cidadeOrigemAlternativa', trecho.cidadeOrigemAlternativa);

    this.props.changeFieldValue('formularioCadastroTrecho',
      'habilitadoTrechoAlternativoLimeteEstadual', trecho.habilitadoTrechoAlternativoLimeteEstadual);

    this.props.changeFieldValue('formularioCadastroTrecho',
      'cidadeDestinoAlternativa', trecho.cidadeDestinoAlternativa);

    this.props.changeFieldValue('formularioCadastroTrecho',
      'rota',
      {
        label: `${trecho.rotaDto.cidadeOrigem.nome}-${trecho.rotaDto.cidadeOrigem.uf} ->
       ${trecho.rotaDto.cidadeDestino.nome}-${trecho.rotaDto.cidadeDestino.uf} `,
        value: trecho.rotaDto.id
      });
    this.props.changeFieldValue('formularioCadastroTrecho',
      'latitude', trecho.latitude);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'longitude', trecho.longitude);

    this.props.changeFieldValue('formularioCadastroTrecho', 
      'habilitadoVenderSemConexao', trecho.habilitadoVenderSemConexao);

    this.props.changeFieldValue('formularioCadastroTrecho',
        'nomeInstalacao', trecho.nomeInstalacao);

    this.props.changeFieldValue('formularioCadastroTrecho',
        'codigoInstalacao', trecho.codigoInstalacao);

    if (trecho.conexaoAtivaTrechoDestino && trecho.conexaoAtivaTrechoDestino.length) {      
      this.props.preencherConexoesUsadas(trecho.conexaoAtivaTrechoDestino.map(it => {
        return {
          id: it.conexaoOrigemId,
          trechoOrigemId: it.trechoOrigemId,
          descricao: it.descricaoConexaoOrigem,
          nome: it.conexaoOrigemId
        }
      }));
    }

    if (trecho.cidadesOrigensVendaDireta && trecho.cidadesOrigensVendaDireta.length) {      
      this.props.preencherCidadeOrigemVendaDireta(trecho.cidadesOrigensVendaDireta.map(it => {
        return {
          id: it.cidadeOrigemId,
          trechoOrigemId: it.trechoOrigemId,
          descricao: it.descricaoCidadeOrigem,
          nome: it.cidadeOrigemId
        }
      }))
    }

  }

  alterarOrdem (trecho, tipo) {
    this.props.alterarOrdem(trecho.id, this.props.idEmpresa, tipo)
      .then(() => {
        this.props.buscarTrechos(this.props.idEmpresa, trecho.rotaDto.id);
      })
  }

  exibirSetaOrdenacao (trecho, tipo, title) {
    if ((trecho.ordem === this.props.trechos[0].ordem && tipo === 'CIMA')
      || (trecho.ordem === this.props.trechos[this.props.trechos.length - 1].ordem && tipo === 'BAIXO')) {
      return;
    }
    return <Autorizacao
      perfisPermitidos={[PERFIL_ADMIN,
        getAdminEmpresa(this.props.idEmpresa),
        getGestorEmpresa(this.props.idEmpresa),
        getOperadorEmpresa(this.props.idEmpresa)]}>
      <a onClick={() => this.alterarOrdem(trecho, tipo)} title={title}>
        {tipo === 'BAIXO' ? <i className="material-icons setas-ordenacao mr-1">
          &#xe5cf;
        </i> : <i className="material-icons setas-ordenacao mr-1">
          &#xe5ce;
        </i>}
      </a>
    </Autorizacao>
  }

  exibirIconesOrdenacao (trecho) {
    return (
      <React.Fragment>
        {this.exibirSetaOrdenacao(trecho, 'CIMA', 'Mover para cima')}
        {trecho.ordem}º
        {this.exibirSetaOrdenacao(trecho, 'BAIXO', 'Mover para baixo')}
      </React.Fragment>
    )
  }

  exibirIconeConexao () {
    if (this.props.trecho && this.props.trecho.conexao) {
      const conexao = this.props.trecho.conexao;
      return <span className="align-self-center tooltip-info">
                <a data-tip data-for={`conexao-${conexao.id}`}>
                  <i className="material-icons ajuda-icon" style={{ color: '#000' }}>&#xe0b3;</i>
                </a>
                <div className="tooltip-ut">
                  <ReactTooltip className="tooltip-ut" id={`conexao-${this.props.trecho.conexao.id}`}
                                type="dark" effect="solid">
                    <div className="row align-items-center">Conexão</div>
                    <div className="row">{conexao.prefixo ? conexao.prefixo : 'Prefixo não informado'}: {conexao.cidadeOrigem.nome}-{conexao.cidadeOrigem.uf} -&gt; {conexao.cidadeDestino.nome}-{conexao.cidadeDestino.uf}</div>
                  </ReactTooltip>
                </div>
              </span>
    }
  }

  exibirIconeCodigoDeBarras () {    
    if (this.props.trecho && this.props.trecho.configuracaoBilhete && this.props.trecho.configuracaoBilhete.length > 0) {
      const configuracaoBilhete = this.props.trecho.configuracaoBilhete[0];
      
      return <span className="row justify-content-center">
                <a data-tip data-for={`configuracao-${configuracaoBilhete.id}`} className="col-lg-2">
                  <img cursor="default" src={iconeBarCode} style={{cursor: 'pointer', color: '#000'}}/>
                </a>
                <div className="tooltip-ut">
                  <ReactTooltip className="tooltip-ut" id={`configuracao-${configuracaoBilhete.id}`}
                                type="dark" effect="solid">
                    <div className="row">{configuracaoBilhete.regra.valor}</div>
                  </ReactTooltip>
                </div>
              </span>
    }
  }

  render () {
    return (
      <div className="geral">
        <div className="resumo">
          <div className="row">
            <div className="col">
              <span className="titulo-mobile">Ordem:&nbsp;</span>{this.exibirIconesOrdenacao(this.props.trecho)}
            </div>
            <div className="col">
              <span className="titulo-mobile">Cidade Origem:&nbsp;</span>{this.props.trecho.cidadeOrigem}
            </div>
            <div className="col">
              <span className="titulo-mobile">Ponto de embarque:&nbsp;</span>{this.props.trecho.pontoEmbarque}
            </div>
            <div className="col">
              <span className="titulo-mobile">Cidade destino:&nbsp;</span>{this.props.trecho.cidadeDestino.nomeComUf} {this.props.trecho.cidadeAlternativa ? `- *${this.props.trecho.cidadeAlternativa}` : ''}
            </div>
            <div className="col">
              <span className="titulo-mobile">Duracao:&nbsp;</span>{this.props.trecho.duracao} hora(s)
            </div>
            <div className="col">
              <span className="titulo-mobile">Quilometragem:&nbsp;</span>{this.props.trecho.quilometragem} KM(s)
            </div>
            <div className="col">
              <span className="titulo-mobile">Taxa de Embarque:&nbsp;</span>R$ {this.props.trecho.taxaEmbarque}
            </div>
            <div className="col">
              <span className="titulo-mobile">Pedágio:&nbsp;</span>R$ {this.props.trecho.pedagio}
            </div>
            <div className="col">
              <Autorizacao
                perfisPermitidos={[PERFIL_ADMIN,
                  getAdminEmpresa(this.props.idEmpresa),
                  getGestorEmpresa(this.props.idEmpresa),
                  getOperadorEmpresa(this.props.idEmpresa)]}>
                <div className="acoes">
                  <div className="botoes">
                    <button type="button" className="btn btn-excluir"
                            data-toggle="modal" key={this.props.trecho.id}
                            data-target="#modalConfirmacaoExclusaoTrecho"
                            onClick={() => this.props.selecionarTrecho(this.props.trecho)}>
                      <i className="material-icons nav-icon">&#xe872;</i>
                    </button>
                    <button type="button" className="btn btn-editar"
                            data-toggle="modal"
                            data-target="#modalCadastrarTrecho"
                            onClick={() => this.selecionarTrecho(this.props.trecho)}>
                      <i className="material-icons nav-icon">&#xe150;</i>
                    </button>
                    <button type="button" className="btn btn-editar"
                            data-toggle="modal"
                            data-target="#modalHistoricoTrecho"
                            onClick={() => {
                              this.selecionarTrecho(this.props.trecho)
                              this.props.buscarUltimosHistoricosTrecho(this.props.trecho.id, this.props.idEmpresa)
                            }}>
                      <img src={iconAudoria} alt="Históricos Rota" />
                    </button>
                  </div>
                </div>
              </Autorizacao>
            </div>
            <div className="col">
              {this.props.trecho.conexao ?
                <div className='row'>{this.exibirIconeConexao()}<strong>Conexão</strong></div>
                : ''}
              {this.props.trecho.configuracaoBilhete &&  this.props.trecho.configuracaoBilhete.length > 0 ?
                <div className='row'>{this.exibirIconeCodigoDeBarras()}<strong style={{marginLeft: 15, marginTop: 2}}>Código</strong></div>
              : ''}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export function mapStateToProps () {
  return {}
}

export default connect(mapStateToProps, {
  changeFieldValue,
  alterarOrdem,
  buscarTrechos,
  buscarUltimosHistoricosTrecho
})(reduxForm({
  form: 'formularioCadastroTrecho'
})(Trecho))
